export default __webpack_public_path__ + "static/Wraki-a8759487106310beeb4019496449d18f.webp";